import { render, staticRenderFns } from "./unsubscrib.vue?vue&type=template&id=867cef32&"
import script from "./unsubscrib.vue?vue&type=script&lang=js&"
export * from "./unsubscrib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports